import { renderInDocument } from '@spotahome/soyuz/client';

import TenantGuaranteesContainer from './main';

renderInDocument(TenantGuaranteesContainer);
